var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0012 75C39.7582 75 39.5155 74.9658 39.281 74.895C23.263 70.0878 12.5 55.625 12.5 38.9038V15C12.5 13.6205 13.6195 12.5025 14.9975 12.5C15.1403 12.5 29.3065 12.395 38.4998 5.50053C39.3885 4.83153 40.6115 4.83153 41.5002 5.50053C50.7262 12.4195 64.8585 12.5 65 12.5C66.3805 12.5 67.5 13.6183 67.5 15V38.9038C67.5 55.6225 56.7395 70.0878 40.7228 74.895C40.4883 74.9658 40.2455 75 40.0012 75ZM17.5 17.395V38.9038C17.5 53.147 26.51 65.5028 39.9988 69.8828C53.49 65.5028 62.5 53.1493 62.5 38.9038V17.395C57.9125 17.0728 47.9408 15.7763 40 10.5543C32.0592 15.7765 22.0875 17.0728 17.5 17.395Z",
    fill: "#2AA7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 55C30.3503 55 22.5 47.1485 22.5 37.5C22.5 27.8515 30.3503 20 40 20C49.6497 20 57.5 27.8515 57.5 37.5C57.5 47.1485 49.6497 55 40 55ZM40 25C33.108 25 27.5 30.608 27.5 37.5C27.5 44.392 33.108 50 40 50C46.892 50 52.5 44.392 52.5 37.5C52.5 30.608 46.892 25 40 25Z",
    fill: "#2AA7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35H42.5V32.5C42.5 31.1183 41.3805 30 40 30C38.6195 30 37.5 31.1183 37.5 32.5V35H35C33.6195 35 32.5 36.1182 32.5 37.5C32.5 38.8818 33.6195 40 35 40H37.5V42.5C37.5 43.8818 38.6195 45 40 45C41.3805 45 42.5 43.8818 42.5 42.5V40H45C46.3805 40 47.5 38.8818 47.5 37.5C47.5 36.1182 46.3805 35 45 35Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmune);
export default __webpack_public_path__ + "static/media/immune.2a10ffd40a0c1f37e4d148793754bcca.svg";
export { ForwardRef as ReactComponent };